import Image from "next/image"
import Link from "next/link"

interface LogoProps {
  className?: string
  width?: number
  height?: number
  linkToDashboard?: boolean
}

export function Logo({ 
  className = "h-8 w-auto", 
  width = 120, 
  height = 30,
  linkToDashboard = false 
}: LogoProps) {
  const logo = (
    <Image 
      src="/assets/ainglr-logo.png" 
      alt="Ainglr" 
      width={width} 
      height={height} 
      className={className}
      priority
    />
  )

  if (linkToDashboard) {
    return (
      <Link href="/dashboard" className="inline-block">
        {logo}
      </Link>
    )
  }

  return logo
}

export function LogoIcon({ className = "h-8 w-8" }: { className?: string }) {
  return (
    <div className={`relative ${className}`}>
      <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
        <circle cx="25" cy="25" r="25" fill="#4AADE8"/>
        <circle cx="25" cy="25" r="16" fill="#5B8DC9"/>
        <circle cx="25" cy="25" r="8" fill="#000000"/>
      </svg>
    </div>
  )
}